var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.active)?_c('Ctx',{ref:"ctx",attrs:{"active":_vm.active,"targetType":"candidacy"},on:{"close":_vm.close}},[_c('Column',{attrs:{"candidacy":_vm.currentActionTarget}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }